import { createAdminAccountSubmissionPreviews } from "./AdminAccountSubmissionPreviews";

export const AdminAccountSubmissionPreviewsAll = createAdminAccountSubmissionPreviews(
	"admin_account_submissions",
	(account) => !account.hasBeenActive,
);
